import Vue from 'vue'
import Router from 'vue-router'
import auth from './middleware/auth'
import remember_token from './middleware/remember_token'
import logout from './middleware/logout'
import ikeaTemplate from './views/IkeaHome.vue'
import rtmartTemplate from './views/RtmartHome.vue'
import homeMainTemplate from './views/Home.vue'

var homeTemplate = homeMainTemplate
var homeMeta = {
  title: process.env.VUE_APP_LOGO
}

var parkingLotNav = null
var defaultFooter = null

if (process.env.VUE_APP_BRAND == 'ikea') {
  homeTemplate = ikeaTemplate
  homeMeta = {
    layout: "logonav",
    footer: "emptynav",
    title: process.env.VUE_APP_LOGO
  }
}

if (process.env.VUE_APP_BRAND == 'ikea-taoyuan') {
  homeTemplate = ikeaTemplate
  homeMeta = {
    layout: "logonav",
    footer: "emptynav",
    title: process.env.VUE_APP_LOGO
  }
}


if (process.env.VUE_APP_BRAND == 'rtmart') {
  homeTemplate = rtmartTemplate
  homeMeta = {
    layout: "logonav",
    footer: "emptynav",
    title: process.env.VUE_APP_LOGO
  }
}

var homeRouter = {
  path: '/',
  name: 'Home',
  meta: homeMeta,
  component: homeTemplate
}

if (process.env.VUE_APP_BRAND == 'liteon') {
  parkingLotNav = 'logonav'
  defaultFooter = 'emptynav'
  homeRouter = {
    path: "/",
    redirect: "/billing_lists"
  }
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    homeRouter,
    {
      path: "*",
      redirect: "/member_center",
    },
    {
      path: '/billing_lists',
      name: 'billing_lists',
      meta: {
        middleware: [auth],
        layout: "chapternav",
        footer: defaultFooter,
        title: "停車帳務 - " + process.env.VUE_APP_LOGO
      },
      component: () => import('./views/BillingLists.vue')
    },
    {
      path: '/billing_view',
      name: 'billing_view',
      meta: {
        middleware: [auth],
        layout: "chapternav",
        footer: defaultFooter,
        title: "停車帳務 - " + process.env.VUE_APP_LOGO
      },
      component: () => import('./views/BillingView.vue')
    },
    {
      path: '/billing_current_view',
      name: 'billing_current_view',
      meta: {
        middleware: [auth],
        layout: "chapternav",
        footer: defaultFooter,
        title: "停車帳務 - " + process.env.VUE_APP_LOGO
      },
      component: () => import('./views/BillingCurrentView.vue')
    },
    {
      path: '/linepay_success',
      name: 'linepay_success',
      meta: {
        layout: "logonav",
        footer: "emptynav",
        title: "付款成功 - " + process.env.VUE_APP_LOGO
      },
      component: () => import('./views/LinePaySuccess.vue')
    },
    {
      path: '/linepay_fail',
      name: "linepay_fail",
      meta: {
        layout: "logonav",
        footer: "emptynav",
        title: "付款失敗 - " + process.env.VUE_APP_LOGO
      },
      component: () => import('./views/LinePayFail.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        title: "聯絡我們 - " + process.env.VUE_APP_LOGO
      },
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/Faq.vue')
    },
    {
      path: '/member_center',
      name: 'member_center',
      component: () => import('./views/MemberCenter.vue'),
      meta: {
        middleware: [logout],
        title: "會員中心 - " + process.env.VUE_APP_LOGO,
        layout: parkingLotNav,
        footer: defaultFooter
      }
    },
    {
      path: '/news_lists',
      name: 'news_lists',
      component: () => import('./views/NewsLists.vue')
    },
    {
      path: '/reservation',
      name: 'reservation',
      meta: {
        middleware: [auth],
        title: "預約停車 - " + process.env.VUE_APP_LOGO,
        layout: parkingLotNav,
        footer: defaultFooter,
      },
      component: () => import('./views/Reservation.vue'),
    },
    {
      path: '/news_view',
      name: 'news_view',
      component: () => import('./views/NewsView.vue')
    },
    {
      path: '/parkinglot_lists',
      name: "parkinglot_lists",
      component: () => import('./views/ParkinglotLists.vue'),
      meta: {
        middleware: [remember_token],
        layout: parkingLotNav,
        title: "找停車場 - " + process.env.VUE_APP_LOGO,
        footer: defaultFooter,
      }
    },
    {
      path: '/parkinglot_map',
      name: "parkinglot_map",
      component: () => import('./views/ParkinglotMap.vue'),
      meta: {
        middleware: [remember_token],
        layout: parkingLotNav,
        title: "找停車場 - " + process.env.VUE_APP_LOGO,
        footer: defaultFooter,
      }
    },
    {
      path: '/parkinglot_view',
      name: "parkinglot_view",
      component: () => import('./views/ParkinglotView.vue'),
      meta: {
        middleware: [remember_token],
        layout: parkingLotNav,
        footer: defaultFooter,
      }
    },
    {
      path: '/settings_invoice',
      name: "settings_invoice",
      meta: {
        middleware: [auth],
        layout: "chapternav",
        title: "發票設定 - " + process.env.VUE_APP_LOGO,
        footer: defaultFooter,
      },
      component: () => import('./views/SettingsInvoice.vue')
    },
    {
      path: '/settings_payment',
      name: "settings_payment",
      meta: {
        middleware: [auth],
        layout: "chapternav",
        title: "付款設定 - " + process.env.VUE_APP_LOGO,
        footer: defaultFooter,
      },
      component: () => import('./views/SettingsPayment.vue')
    },
    {
      path: '/settings_plate',
      name: "settings_plate",
      meta: {
        middleware: [auth],
        layout: "chapternav",
        title: "車牌設定 - " + process.env.VUE_APP_LOGO,
        footer: defaultFooter,
      },
      component: () => import('./views/SettingsPlate.vue')
    },
    {
      path: '/settings_profile',
      name: "settings_profile",
      meta: {
        middleware: [auth],
        layout: "chapternav",
        title: "個人設定 - " + process.env.VUE_APP_LOGO,
        footer: defaultFooter,
      },
      component: () => import('./views/SettingsProfile.vue')
    },
    {
      path: '/scanner',
      name: "scanner",
      meta: {
        middleware: [auth],
        layout: "logonav",
        footer: "emptynav",
        title: "發票掃描 - " + process.env.VUE_APP_LOGO,
      },
      component: () => import('./views/ScanView.vue')
    },
    {
      path: '/webaps',
      name: 'webaps', 
      meta: {
        layout: "logonav",
        footer: "emptynav"
      },
      component: () => import('./views/WebAps.vue')
    },
    {
      path: '/ikea_home',
      name: "ikea_home",
      meta: {
        layout: "logonav",
        footer: "emptynav"
      },
      component: () => import('./views/IkeaHome.vue')
    },
    {
      path: '/rtmart_home',
      name: "rtmart_home",
      meta: {
        layout: "logonav",
        footer: "emptynav"
      },
      component: () => import('./views/RtmartHome.vue')
    },
    {
      path: '/location',
      name: "location",
      meta: {
        layout: "logonav",
        footer: "emptynav"
      },
      component: () => import('./views/SearchLocation.vue')
    }
  ]
})

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Than run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  
  // change favicon
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = "/img/" + process.env.VUE_APP_BRAND + "/favicon.png";
  document.getElementsByTagName('head')[0].appendChild(link);

  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = process.env.VUE_APP_LOGO
  }

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;